// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nu-logo{display:flex;justify-content:center}nu-logo .img-logo{height:100%}`, "",{"version":3,"sources":["webpack://./src/shared/components/nu-logo/logo.component.scss"],"names":[],"mappings":"AAAA,QACI,YAAA,CACA,sBAAA,CAEA,kBACI,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
